"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPolicyChangeDefinitionList = exports.PolicyChangeDefinitionList = void 0;
var tslib_1 = require("tslib");
var core_money_1 = require("@newfront-insurance/core-money");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var definition_list_1 = require("../definition-list");
var stack_1 = require("../stack");
var text_1 = require("../text");
function PolicyChangeDefinitionList(props) {
    var policyChangeDefinition = props.policyChangeDefinition, notes = props.notes;
    return (react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 8 },
        react_1.default.createElement(definition_list_1.DefinitionList, { items: createPolicyChangeDefinitionList(policyChangeDefinition), labelWidth: "170px" }),
        react_1.default.createElement(text_1.Text, { color: "light", size: "small", prewrap: true }, notes)));
}
exports.PolicyChangeDefinitionList = PolicyChangeDefinitionList;
function createPolicyChangeDefinitionList(props) {
    var policyNumber = props.policyNumber, carrierName = props.carrierName, changeEffectiveDate = props.changeEffectiveDate, totalCost = props.totalCost, type = props.type;
    var items = [];
    if (type) {
        items.push({
            type: 'document',
            title: 'Type',
            value: type,
        });
    }
    items.push({
        type: 'number',
        title: 'Policy number',
        value: policyNumber,
    });
    if (carrierName) {
        items.push({
            type: 'business',
            title: 'Carrier',
            value: carrierName,
        });
    }
    items.push({
        type: 'date',
        title: 'Change effective date',
        value: changeEffectiveDate ? "".concat((0, string_formatters_1.standardUTCDateFormat)(changeEffectiveDate)) : 'TBD',
    }, {
        type: 'currency',
        title: 'Total cost',
        value: (0, core_money_1.moneyToString)(totalCost, { fractionDigits: 2 }),
    });
    return items;
}
exports.createPolicyChangeDefinitionList = createPolicyChangeDefinitionList;
//# sourceMappingURL=index.js.map